import React from "react";
import { useTeamLocale } from "./TeamLocaleContext";

const PRESET_IDS = ["all", "7d", "30d", "90d", "custom"];

const toISODate = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const buildRangeFromPreset = (presetId) => {
  if (presetId === "all") return { from: "", to: "", preset: "all" };
  const to = new Date();
  const from = new Date();
  const days = presetId === "7d" ? 7 : presetId === "90d" ? 90 : 30;
  from.setDate(from.getDate() - days);
  return { from: toISODate(from), to: toISODate(to), preset: presetId };
};

const DateRangeFilter = ({ value, onChange }) => {
  const { t } = useTeamLocale();
  const { preset, from, to } = value;

  const setPreset = (id) => {
    if (id === "custom") {
      onChange({ ...value, preset: "custom" });
      return;
    }
    onChange(buildRangeFromPreset(id));
  };

  return (
    <div className="team-date-filter">
      <span className="team-date-filter-label">{t("dateRange.label")}</span>
      <div className="team-date-presets">
        {PRESET_IDS.map((id) => (
          <button
            key={id}
            type="button"
            className={preset === id ? "is-active" : ""}
            onClick={() => setPreset(id)}
          >
            {t(`dateRange.${id}`)}
          </button>
        ))}
      </div>
      {preset === "custom" && (
        <div className="team-date-custom">
          <label>
            {t("dateRange.from")}
            <input
              type="date"
              value={from}
              onChange={(e) => onChange({ ...value, from: e.target.value, preset: "custom" })}
            />
          </label>
          <label>
            {t("dateRange.to")}
            <input
              type="date"
              value={to}
              onChange={(e) => onChange({ ...value, to: e.target.value, preset: "custom" })}
            />
          </label>
        </div>
      )}
    </div>
  );
};

export default DateRangeFilter;
